import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DayPicker } from 'react-day-picker'

import 'react-day-picker/dist/style.css'

const DatePickerCalendar = ({
  monthStart,
  disabledAfter,
  disabledBefore,
  disabledDays = [],
  disabledDaysOfWeek,
  onChange,
  onMonthChange,
}) => {
  const [selectedDay, setSelectedDay] = useState()

  const handleSelect = (day) => {
    if (day) {
      setSelectedDay(day)
      onChange && onChange(day)
    } else {
      setSelectedDay(undefined)
      onChange && onChange(undefined)
    }
  }

  const handleMonthChange = (month) => {
    setSelectedDay(undefined)
    onChange && onChange(undefined)
    onMonthChange && onMonthChange(month)
  }

  // Combine all disabled day conditions
  const getDisabledDays = () => {
    const disabled = [...(disabledDays || [])]
    
    if (disabledDaysOfWeek && disabledDaysOfWeek.length > 0) {
      disabled.push({ dayOfWeek: disabledDaysOfWeek })
    }
    
    if (disabledBefore) {
      disabled.push({ before: disabledBefore })
    }
    
    if (disabledAfter) {
      disabled.push({ after: disabledAfter })
    }
    
    return disabled
  }

  return (
    <div className="flex justify-center w-full">
      <div className="transform scale-110 origin-center">
        <DayPicker
          mode="single"
          selected={selectedDay}
          onSelect={handleSelect}
          month={monthStart}
          onMonthChange={handleMonthChange}
          fromDate={disabledBefore}
          toDate={disabledAfter}
          disabled={getDisabledDays()}
        />
      </div>
    </div>
  )
}

DatePickerCalendar.propTypes = {
  monthStart: PropTypes.instanceOf(Date),
  disabledAfter: PropTypes.instanceOf(Date),
  disabledBefore: PropTypes.instanceOf(Date),
  disabledDays: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  disabledDaysOfWeek: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func.isRequired,
}

export default DatePickerCalendar
